'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _glamor = require('glamor');
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _componentThemes$load = _themes.componentThemes.loading,
  loadingStyle = _componentThemes$load.loadingStyle,
  loadingTheme = _componentThemes$load.loadingTheme;
var fade = _glamor.css.keyframes({
  '0%': {
    opacity: 0.1
  },
  '50%': {
    opacity: 1
  },
  '100%': {
    opacity: 0.1
  }
});
var dotStyles = function dotStyles(props) {
  var theme = loadingTheme(props.theme);
  return {
    display: 'inline-block',
    animationName: fade,
    animationDuration: '1.7s',
    animationIterationCount: 'infinite',
    animationFillMode: 'both',
    animationDelay: 0.3 * props.position + 's',
    margin: theme.space_xs,
    borderRadius: '50%',
    backgroundColor: theme[loadingStyle('color')],
    width: '1em',
    height: '1em'
  };
};
var overlayStyles = function overlayStyles(_ref) {
  var overlay = _ref.overlay;
  if (overlay) {
    return {
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)'
    };
  }
};
var inlineStyles = function inlineStyles(_ref2) {
  var inline = _ref2.inline;
  if (inline) {
    return {
      width: '.6em',
      height: '.6em',
      margin: '0 .2rem'
    };
  }
};
var Dot = (0, _glamorous2.default)('span')(dotStyles, overlayStyles, inlineStyles);
exports.default = Dot;